/* KramNordic – tema-funktioner */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Pris i butikkens eget format */
  function money(cents) {
    const format = (window.KN && window.KN.moneyFormat) || '{{amount_with_comma_separator}} kr';
    const value = Number(cents) / 100;
    const fmt = (decimals, thousands, decimal) => {
      const parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_space_separator: fmt(2, ' ', ','),
      amount_with_apostrophe_separator: fmt(2, "'", '.')
    })[key] || fmt(2, '.', ','));
  }

  /* Topbjælke: skifter punkt på mobil */
  function initBar() {
    const bar = $('[data-bar]');
    if (!bar || reduceMotion) return;
    const items = $$('.kn-bar__item', bar);
    if (items.length < 2) return;
    const mq = window.matchMedia('(max-width: 749px)');
    let i = 0;
    setInterval(() => {
      if (!mq.matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3600);
  }

  /* Mobilmenu */
  function initDrawer() {
    const drawer = $('[data-drawer]');
    const openBtn = $('[data-drawer-open]');
    if (!drawer || !openBtn) return;
    const open = () => {
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = $('a, button', drawer.querySelector('.kn-drawer__panel'));
      if (first) first.focus();
    };
    const close = () => {
      drawer.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(() => { drawer.hidden = true; }, 320);
      openBtn.focus();
    };
    openBtn.addEventListener('click', open);
    $$('[data-drawer-close]', drawer).forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* Galleri */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    if (!track || !thumbs.length) return;
    const slides = $$('.kn-gallery__slide', track);
    const setActive = (index) => thumbs.forEach((t, n) => t.classList.toggle('is-active', n === index));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const index = Number(thumb.dataset.thumb);
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(index);
    }));
    const go = (dir) => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      const next = (index + dir + slides.length) % slides.length;
      track.scrollTo({ left: slides[next].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(next);
    };
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });
  }

  /* Produktboks: varianter, pakker og køb */
  function initProduct(section) {
    const dataEl = $('[data-product-json]', section);
    const form = $('[data-product-form]', section);
    if (!dataEl || !form) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const variantInput = $('[data-variant-input]', form);
    const qtyInput = $('[data-qty-input]', form);
    const addBtn = $('[data-add]', form);
    const addLabel = $('[data-add-label]', form);
    const errorEl = $('[data-error]', form);
    const priceEl = $('[data-price]', section);
    const compareEl = $('[data-compare]', section);
    const stickyPrice = $('[data-sticky-price]', section);
    const stockText = $('[data-stock-text]', section);
    const fieldsets = $$('.kn-opt', form);
    const bundles = $$('[data-bundle]', form);

    let variant = data.variants.find((v) => String(v.id) === variantInput.value) || data.variants[0];

    const selectedOptions = () => fieldsets.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const currentBundle = () => bundles.find((b) => b.checked) || null;

    function render() {
      if (!variant) return;
      variantInput.value = variant.id;
      const bundle = currentBundle();
      const qty = bundle ? Number(bundle.dataset.qty) : 1;
      qtyInput.value = qty;

      priceEl.textContent = money(variant.price);
      if (compareEl) {
        const showCompare = variant.compare > variant.price;
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = money(variant.compare);
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.price);

      let total = variant.price;
      bundles.forEach((b) => {
        const q = Number(b.dataset.qty);
        const pct = Number(b.dataset.pct) || 0;
        const full = variant.price * q;
        const sum = Math.round(full - (full * pct) / 100);
        const box = b.closest('.kn-bundle');
        const totalEl = $('[data-bundle-total]', box);
        const fullEl = $('[data-bundle-full]', box);
        if (totalEl) totalEl.textContent = money(sum);
        if (fullEl) fullEl.textContent = money(full);
        if (b === bundle) total = sum;
      });

      if (variant.available) {
        addBtn.disabled = false;
        addLabel.textContent = data.showTotal === false ? data.addLabel : data.addLabel + ' · ' + money(total);
        if (stockText) stockText.textContent = data.inStock || 'På lager';
      } else {
        addBtn.disabled = true;
        addLabel.textContent = data.soldOut;
        if (stockText) stockText.textContent = data.soldOut;
      }

      fieldsets.forEach((fs) => {
        const out = $('[data-option-value]', fs);
        const checked = $('input:checked', fs);
        if (out && checked) out.textContent = checked.value;
      });

      if (data.updateUrl && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach((fs) => fs.addEventListener('change', () => {
      const wanted = selectedOptions();
      const match = data.variants.find((v) => v.options.every((opt, n) => wanted[n] === null || wanted[n] === opt));
      if (match) variant = match;
      render();
    }));
    bundles.forEach((b) => b.addEventListener('change', render));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!variant || !variant.available) return;
      errorEl.hidden = true;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(window.KN.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: Number(qtyInput.value) || 1 }] })
        });
        const body = await res.json();
        if (!res.ok) throw new Error(body.description || body.message || 'Varen kunne ikke lægges i kurven.');
        window.location.href = window.KN.routes.cart;
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      }
    });

    /* Fast knap i bunden på mobil */
    const sticky = $('[data-sticky]', section);
    const stickyBtn = $('[data-sticky-btn]', section);
    if (sticky && stickyBtn) {
      sticky.hidden = false;
      const update = () => {
        const rect = addBtn.getBoundingClientRect();
        const footer = document.querySelector('.kn-footer');
        const nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        sticky.classList.toggle('is-visible', rect.bottom < 0 && !nearEnd);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      stickyBtn.addEventListener('click', () => {
        const target = fieldsets[0] || $('[data-buy]', section);
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }

    render();
  }

  /* Dialoger, fx størrelsesguide */
  function initDialogs(root = document) {
    $$('[data-dialog-open]', root).forEach((btn) => {
      const dialog = document.getElementById(btn.dataset.dialogOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      btn.addEventListener('click', () => dialog.showModal());
      $$('[data-dialog-close]', dialog).forEach((c) => c.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    });
  }

  /* Kurv: opdater når antal ændres */
  function initCart() {
    const form = $('[data-cart-form]');
    if (!form) return;
    $$('[data-cart-qty]', form).forEach((input) => input.addEventListener('change', () => form.submit()));
  }

  /* Vandrette kort på mobil: prikker der følger med */
  function initCarousel(root) {
    const track = $('[data-carousel-track]', root);
    const dots = $('[data-carousel-dots]', root);
    if (!track || !dots) return;
    const items = Array.from(track.children);
    dots.innerHTML = '';
    items.forEach((item, n) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Vis kort ' + (n + 1));
      if (n === 0) b.className = 'is-active';
      b.addEventListener('click', () => track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }));
      dots.appendChild(b);
    });
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const w = items[0].getBoundingClientRect().width || 1;
        const index = Math.min(items.length - 1, Math.round(track.scrollLeft / w));
        Array.from(dots.children).forEach((d, n) => d.classList.toggle('is-active', n === index));
        ticking = false;
      });
    }, { passive: true });
  }

  function initSections(root = document) {
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-product-section]', root).forEach(initProduct);
    initDialogs(root);
  }

  window.KN = window.KN || {};
  window.KN.initSections = initSections;

  document.addEventListener('DOMContentLoaded', () => {
    initBar();
    initDrawer();
    initSections();
    initCart();
  });

  /* Tema-editoren genindlæser sektioner: start dem igen */
  document.addEventListener('shopify:section:load', (e) => {
    initSections(e.target);
    if (e.target.querySelector('[data-drawer]')) initDrawer();
    if (e.target.querySelector('[data-bar]')) initBar();
  });
})();
